export const maybePluralize = (
  count: number,
  noun: string,
  suffix: string = 's'
): string => `${count ?? '...'} ${noun}${count !== 1 ? suffix : ''}`

export const cutText = (text: string, limit: number = 45): string =>
  text.length < limit ? text : `${text.slice(0, limit)}...`

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1)
